import { Component } from '@angular/core';

@Component({
  selector: 'cigna-layout-page-not-found',
  templateUrl: './layout-page-not-found.component.html',
  styleUrls: ['./layout-page-not-found.component.scss'],
})
export class LayoutPageNotFoundComponent {}
